import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ESpinner from "components/others/Spinner";
import * as apiObject from "api/apiObjects";
import * as apiObject4Team from "api/apiObject4Team";
import { useObjectCard } from "../context/ObjectCardProvider";
import ExpendInfo from "./ExpendInfo";
import { useAuth } from "context/AuthContext";
 
const OffExpendInfo = ({objectId, show,setShow}) => {

    const { t } = useTranslation(['Objects'])
    const { auth } = useAuth();
    const [ expend, setxEpend ] = useState(null);

    const fetchExpendTeam = async () =>{ 
        
        const resExpend = (auth?.user?.access?.role == 'manager')
            ? await apiObject.getObjectExpend(objectId, show)
            : await apiObject4Team.getObjectExpend(objectId, show);
            
        setxEpend(resExpend);
 
    }

    const handleHide = () =>{
        setShow(false);
        setTimeout(() => {
            setxEpend(null);
        }, 300);
    }
 
    useEffect(()=>{
        if (show) fetchExpendTeam()
            else handleHide();
    },[show])

    return (
        <Offcanvas 
            show={show!==false} 
            onHide={handleHide}
            placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleOperInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="px-0 position-relative"> 
                {expend
                    ? (<ExpendInfo expend={expend}/>)
                    : (<ESpinner/>)}
            </Offcanvas.Body>
        </Offcanvas>
         
    )
}

export default OffExpendInfo;